/**
 * Hated passing these as these props; it was getting too convoluted.
 * Depending on the direction of the app it would probably be nice to store these in a separate table
 * Also might make these editable in the admin dashboard
 */

const companyName = {
    number: "1/3",
    question: "What is the name of your company?",
    description: "",
}

const problemStatement = {
    number: "2/3",
    question: "What problem are you solving?",
    description: `e.g.: Founders today struggle to build companies and 
    remain true to their purpose while scaling them. They start 
    their business with a great purpose, but on the way end up losing focus. 
    That causes increased depression rates among founders, and ultimately 
    less happy employees, and far less successful businesses.`
}

const problemSolution = {
    number: "3/3",
    question: "What is the solution you're bringing?",
    description: `e.g.: We are building a brand package for founders, guiding them
    through building their purpose statement, and brand personality
    from the get-go. This way, they don't only get the logo and brand
    collateral, but also the guide that will keep them going. All this
    through a self-guided process, to allow for the results to be affordable
    even for starting-out businesses.`
}

export const questions = {
    companyName: companyName,
    problemStatement: problemStatement,
    problemSolution: problemSolution,
}

const companyNameVideo = {
    url: "https://www.dropbox.com/scl/fi/p9xoclckxbcn32wa6ygw5/1-Welcome.mp4?rlkey=gtccladqszb1n6gdi89t1qphp&raw=1"
}

const problemStatementVideo = {
    url: "https://www.dropbox.com/scl/fi/jj7hg18dbhg1w3fi8h5oe/2-Problem.mp4?rlkey=b7lq0sesa8xl59f6khi96ekiu&raw=1"
}

const problemSolutionVideo = {
    url: "https://www.dropbox.com/scl/fi/clay0layd8szwwkzqi49f/3-Solution.mp4?rlkey=53gdif7fncvm42f3azmvyvmaa&raw=1"
}

export const videos = {
    companyNameVideo: companyNameVideo,
    problemStatementVideo: problemStatementVideo,
    problemSolutionVideo: problemSolutionVideo
}